import {
    Button,
    GlanceLoader,
    Alert,
  } from '../ui-components';
  import React from 'react';

function ErrorState({buttonText, onClick, errorMessage, gicon}) {

    return (
        <div className='SizeWrapper'>
            <div className='buttonAndTextWrapper'>
                <div className='rowAlign'>
                    <div className='Spinner'>
                    { gicon && <GlanceLoader size="12" spinning={false}></GlanceLoader> }
                    </div>
                    <span className="wrapper" style={{ display: "inline-block" }}>
                    
                    <Button size="small" variant="secondary" shape="rounded-full" animation="false" onClick={()=>(typeof(onClick) === typeof(Function)) ? onClick() : console.log("Button pressed")}>{buttonText}</Button>
                    
                    </span>
                </div>
                <div className='AlertWrapper'>
                    <Alert size="small" severity="error" variant="open" heading={errorMessage} closable="false" /> 
                </div>
            </div>  
        </div>
        
        
    );
}

export default ErrorState;